module.exports = __webpack_public_path__ + "static/media/guide-desktop-body.754a3982.jpg";